import { CardDescriptionP, Container, ExpandableCard, H1, P500 } from "./StaticPagesComponents";
import React, { Fragment } from "react";
import { FooterAds } from "../../components/ads/FooterAds";

export const DMCAPage = () => {
  return (
    <Fragment>
      <Container className="page narrow">
        <H1>
          RedGIFs DMCA Copyright Policy
        </H1>

        <P500>
          Vergil Services, Inc. ("Company") has adopted the following general policy toward copyright infringement
          in accordance with the <a href="http://lcweb.loc.gov/copyright/legislation/dmca.pdf">
          Digital Millennium Copyright Act.</a> The address of the Designated Agent to Receive Notification
          of Claimed Infringement ("Designated Agent") is listed at the end of this policy.
          <br /><br />
          Procedure for Reporting Copyright Infringement:
          <br /><br />
          If you believe that material or content residing on or accessible through Company's websites or services infringes a copyright,
          please send a notice of copyright infringement containing the following information to the Designated Agent listed below:
        </P500>
        <P500 sx={{ paddingLeft: "1rem" }}>
          1.A physical or electronic signature of a person authorized to act on behalf of the owner of the copyright that has been allegedly
          infringed;
          <br />
          2.Identification of works or materials being infringed;
          <br />
          3.Identification of the material that is claimed to be infringing including information regarding the location of the infringing materials
          that the copyright owner seeks to have removed, with sufficient detail so that Company is capable of finding and verifying its existence;
          <br />
          4. Contact information about the notifier including address, telephone number and, if available, e-mail address;
          <br />
          5. A statement that the notifier has a good faith belief that the material is not authorized by the copyright owner, its agent, or the law;
          and
          <br />
          6. A statement made under penalty of perjury that the information provided is accurate and the notifying party is authorized to make the
          complaint on behalf of the copyright owner.
        </P500>

        <P500>
          If we receive a takedown notice in accordance with the foregoing, we will remove the material cited in the notice and attempt to notify any
          user who uploaded the allegedly infringing material if we have their contact information. Any such user will have the opportunity to submit
          a “counter-notice” as set forth below. If we determine that any user has repeatedly infringed upon the intellectual property rights of
          others, we will disable any accounts that user has with us when appropriate.
          <br /><br />
          Please contact the Designated Agent to Receive Notification of Claimed Infringement for Company
          at <a href="mailto:dmca@redgifs.com?subject=DMCA">dmca@redgifs.com</a>. Important: Please email us in urgent
          cases to avoid any delays.
        </P500>

        <ExpandableCard sx={{ marginBottom: "40px" }}>
          <CardDescriptionP>
            Vergil Services Inc. <br />
            Subject: RedGIFs DMCA <br />
            11766 Wilshire Blvd, Suite 900 <br />
            Los Angeles, California 90025,United States <br />
          </CardDescriptionP>
        </ExpandableCard>
      </Container >

      <FooterAds/>
    </Fragment>
  );
};
